{
  "name": "buble",
  "version": "0.12.5",
  "description": "The blazing fast, batteries-included ES2015 compiler",
  "main": "dist/buble.umd.js",
  "jsnext:main": "dist/buble.es.js",
  "files": [
    "bin",
    "src",
    "dist",
    "register.js",
    "README.md"
  ],
  "scripts": {
    "build": "npm run build:umd && npm run build:es && npm run build:browser",
    "build:umd": "rollup -c -f umd -o dist/buble.umd.js",
    "build:browser": "rollup -c --environment DEPS -f umd -o dist/buble.deps.js",
    "build:es": "rollup -c -f es6 -o dist/buble.es.js",
    "test": "mocha test/test.js --compilers js:buble/register",
    "pretest": "npm run build:umd && npm run build:browser",
    "test:node": "mocha test/test.js --compilers js:buble/register",
    "pretest:node": "npm run build:umd",
    "prepublish": "npm test && npm run build:es"
  },
  "bin": {
    "buble": "./bin/buble"
  },
  "repository": {
    "type": "git",
    "url": "git+https://gitlab.com/Rich-Harris/buble.git"
  },
  "keywords": [
    "javascript",
    "transpilation",
    "compilation",
    "esnext",
    "es2015",
    "es2017",
    "es6",
    "es7"
  ],
  "author": "Rich Harris",
  "license": "MIT",
  "bugs": {
    "url": "https://gitlab.com/Rich-Harris/buble/issues"
  },
  "homepage": "https://gitlab.com/Rich-Harris/buble#README",
  "devDependencies": {
    "buble": "0.8.2",
    "console-group": "^0.2.1",
    "eslint": "^2.10.1",
    "glob": "^7.0.3",
    "mocha": "^2.4.5",
    "regexpu-core": "^2.0.0",
    "rimraf": "^2.5.2",
    "rollup": "^0.26.3",
    "rollup-plugin-buble": "^0.8.0",
    "rollup-plugin-commonjs": "^2.2.1",
    "rollup-plugin-json": "^2.0.0",
    "rollup-plugin-node-resolve": "^1.5.0",
    "source-map": "^0.5.6",
    "source-map-support": "^0.4.0"
  },
  "dependencies": {
    "acorn": "^3.1.0",
    "acorn-jsx": "^3.0.1",
    "acorn-object-spread": "^1.0.0",
    "chalk": "^1.1.3",
    "magic-string": "^0.14.0",
    "minimist": "^1.2.0",
    "os-homedir": "^1.0.1"
  }
}
